import React, { useEffect, useState } from "react";
import { useNavigate,  } from "react-router-dom";
import PhotoLibrarySharpIcon from "@mui/icons-material/PhotoLibrarySharp";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import DownloadIcon from "@mui/icons-material/Download";

import usePgiModules from "../../../hooks/useModules";
import StaticSlider from "../../../components/products/StaticSlider";
import Galeria3DModels from "../../../components/galeria3d/Galeria3DModels";
import ContainerInfo from "../../../components/products/ContainerInfo";
import FaqsDinamic from "../../../components/faqs/FaqsDinamic";


const Products = ({ product, auditoria }) => {

  const navigate = useNavigate();
  const [lowerTitle, setLowerTitle] = useState("");
  let descargasVisibles; //usarloLinea


  descargasVisibles = product?.filename?.filter(
    (item) => item.state === true && item.deleted !== true
  );

  const AbrirGaleria = () => {
    product.imageGallery.length > 0 &&
      navigate("/galeria", {
        replace: true,
        state: {
          imageGallery: product.imageGallery,
          url: window.location.href
        }
      }); // esta es la logica para abrir galeria y pasar por parametro 'state' el prod que se va a mostrar
  };

  return (
    <>
        <section className="contenedor-principal">
          <StaticSlider product={product} />

          {product?.type !== undefined && product?.type == "productoEspecial" ? (
            <Galeria3DModels nameProd={product?.title} desktop={true} />
          ) : (
            ""
          )}
          {product?.imageGallery?.length > 0 && product?.galleryEnabled && (
            <>
              <div
                onClick={AbrirGaleria}
                id="boton-galeria"
                className="description_desktop boton-galeria"
              >
                <p className="p-galeria">GALERÍA</p>
                {/* <PhotoIcon /> */}
                <PhotoLibrarySharpIcon />
              </div>
            </>
          )}

          <ContainerInfo product={product} />
        </section>

        {product.type !== undefined && product?.type === "productoEspecial" ? (
          <>
            <section id="bloq-inferior" className="container">
              <ul className="check-list ">
                {product?.benefit?.map((item, index) => (
                  <li key={index} className="col-10 col-lg-6 col-md-6">
                    <span className="material-icons-outlined">
                      {item.iconBenefit ? item.iconBenefit : "check_box"}
                    </span>{" "}
                    {item.textBenefit}
                  </li>
                ))}
              </ul>
            </section>
          </>
        ) : (
          <>
            <section id="bloq-inferior" className="container">
              <ul className="check-list ">
                {product?.benefit?.map((item, index) => (
                  <li key={index} className="col-10 col-lg-6 col-md-6">
                    <span className="material-icons-outlined">
                      {item.iconBenefit ? item.iconBenefit : "check_box"}
                    </span>{" "}
                    {item.textBenefit}
                  </li>
                ))}
              </ul>
            </section>
          </>
        )}
        {/* Ilustraciones de colocado  */}
        <section className="">
          {product?.imageProduct && (
            <div className="container bloque_img_product ">
              {" "}
              {/* img-instal */}
              <div className="foto-instal image-1 shadow">
                <img
                  src={product?.imageProduct ? product?.imageProduct[0]?.url : ""}
                  alt={product?.imageProduct ? product?.imageProduct[0]?.alt : product?.title}
                  title={product?.title}
                  className="image img-block"
                />
              </div>
              <div className="foto-instal image-2 shadow">
                <img
                  src={product?.imageProduct ? product?.imageProduct[1]?.url : ""}
                  alt={product?.imageProduct ? product?.imageProduct[1]?.alt : product?.title}
                  title={product?.title}
                  className={`${product.imageProduct[1] ? "img-block image " : "image"} `}
                />
              </div>
            </div>
          )}

          {/* TEXTO Y BOTONES */}

          {product.type !== undefined && product?.type == "productoEspecial" ? (
            <div className="bg-break">
              <div className="container text-button">
                <article className="info-text col-12 col-md-12 col-lg-9 mb-4 pb-4">
                  <h3 className="padding_top">{product?.titleSubDescription}</h3>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: product?.subdescription
                    }}
                  ></p>
                </article>
                <div role="presentation" className="settingscol-buttons col-3 columna-3">
                  <div className={` ${descargasVisibles?.length === 0 ? "d-none" : ""}`}>
                    <h3>Descargas</h3>
                    <ul className="settings__lista-descargas">
                      {product?.filename?.map(
                        (item, index) =>
                          item.state === true &&
                          item.deleted === false && (
                            <li key={index}>
                              <DownloadIcon />
                              <a
                                href={item?.url}
                                target="_blank"
                                rel="noreferrer"
                                title={`Descargar ${item?.filename}`}
                              >
                                {item?.title}
                              </a>
                            </li>
                          )
                      )}
                    </ul>
                  </div>
                  <div className="">
                    {product?.faqs?.length !== 0 && product?.faqsEnabled && (
                      <FaqsDinamic vistaProducto={true} producto={product} />
                    )}
                    <button className="settings_button-border button-b-primary_2">
                      <a href="/contacto" title={`Dónde comprar ${product?.title}`}>
                        Consulta técnica <ArrowForwardIcon />
                      </a>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="bg-break">
              <div className="container text-button">
                <article className="info-text col-12 col-md-12 col-lg-9 pb-4">
                  <h3 className="padding_top text-center mb-3">{product?.titleSubDescription}</h3>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: product?.subdescription
                    }}
                  ></p>
                </article>
                <div
                  role="presentation"
                  className="settings__col-buttons col-12 col-md-12 col-lg-3 "
                >
                  <div className={` ${descargasVisibles?.length === 0 ? "d-none" : ""}`}>
                    <h3>Descargas</h3>
                    <ul className="settings__lista-descargas">
                      {product?.filename?.map(
                        (item, index) =>
                          item.state === true &&
                          item.deleted === false && (
                            <li key={index}>
                              <DownloadIcon />
                              <a
                                href={item?.url}
                                target="_blank"
                                rel="noreferrer"
                                title={`Descargar ${item.filename}`}
                              >
                                {item?.title}
                              </a>
                            </li>
                          )
                      )}
                    </ul>
                  </div>
                  <div className="">
                    <button
                      className={`settings_button-pleno bg-p-primary_2 ${
                        product.instalationStepsEnabled && product.instalationSteps?.length !== 0
                          ? ""
                          : "d-none"
                      }`}
                    >
                      <a href={`/instalacion/${lowerTitle}`} title={`Instalación de ${lowerTitle}`}>
                        Instalación <ArrowForwardIcon />
                      </a>
                    </button>
                    {product.faqs?.length !== 0 && product.faqsEnabled && (
                      <FaqsDinamic vistaProducto={true} producto={product} />
                    )}
                    <button className="settings_button-border button-b-primary_2">
                      <a href="/donde-comprar" title={`Dónde comprar ${product.title}`}>
                        DONDE COMPRAR <ArrowForwardIcon />
                      </a>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </section>
     
    </>
  );
};

export default Products;
